import type {ElementModels} from "@kontent-ai/delivery-sdk";

export const useCustomCss = () => {
    const siteStore = useSiteStore()
    const customCssAssetLinks = computed(() => {
        return siteStore.siteConfig.elements.customCss.value.length > 0
            ? siteStore.siteConfig.elements.customCss.value.map(
                (asset: ElementModels.AssetModel) => asset.url
            )
            : null
    })

    const styleSheets = []

    for (const link of customCssAssetLinks.value || []) {
        styleSheets.push(link)
    }

    if (styleSheets.length === 0) {
        return
    }
    //add stylesheets to the head
    useHead({
        link: styleSheets.map((href) => ({
            rel: 'stylesheet',
            href
        }))
    })
}